import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { toast } from "react-toastify";
import { useStore } from "../../app/stores/store";
import { uploadExcelFile } from "../../app/services/CartService";
import { ApiResponse } from "../../app/models/ApiResponse";

const UploadExcel: React.FC = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { outletStore, cartStore } = useStore();
  const { selectedOutlet } = outletStore;

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const file = e.target.files?.[0];
    if (file) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ];

      if (!allowedTypes.includes(file.type)) {
        toast.error("Only XLSX, XLS, and XLSM files are allowed.");
        return;
      }

      setSelectedFile(file);
    }
  };

  const handleSubmit =async ()=>{
    const formData = new FormData();
      formData.append("file", selectedFile!);
      if (
        selectedOutlet &&
        selectedOutlet.id !== undefined &&
        selectedOutlet.id !== null
      ) {
        formData.append("outlet_id", String(selectedOutlet.id));
      } else {
        toast.error("No outlet selected.");
        return;
      }
      toast.success("Uploading Please wait...");
      try {
        const res = (await uploadExcelFile(formData)) as ApiResponse<any>;
        if (res.status === "success") {
          toast.success(res.message);
          cartStore.loadCartItems(selectedOutlet.id);
          setSelectedFile(null);
        } else {
          toast.error(res.message || "Failed to load Excel Sheet");
           setSelectedFile(null);
        }
      } catch (error) {
        toast.error("Failed to upload file.");
         setSelectedFile(null);
      }
  }
  return (
    <>
      <Box mt={2}>
        <input
          accept=".xlsx,.xls,.xlsm"
          type="file"
          id="excel-upload"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
        {selectedFile && (
          <Box mb={2} sx={{ color: "#00703C" }}>
            <strong>Selected File:</strong> {selectedFile.name}
          </Box>
        )}
        {selectedFile ? (
          <Button
              variant="contained"
              component="span"
              onClick={handleSubmit}
              fullWidth
              sx={{
                textTransform: "none",
                backgroundColor: "#00703C",
                "&:hover": {
                  backgroundColor: "#005c30",
                },
              }}
            >
              Submit
            </Button>
        ) : (
          <label htmlFor="excel-upload">
            <Button
              variant="contained"
              component="span"
              startIcon={<CloudUploadIcon />}
              fullWidth
              sx={{
                textTransform: "none",
                backgroundColor: "#00703C",
                "&:hover": {
                  backgroundColor: "#005c30",
                },
              }}
            >
              Upload Excel File
            </Button>
          </label>
        )}
      </Box>
      <Box textAlign={"right"}>
        <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          fullWidth
          href="/products_template.xlsx"
          download
          sx={{
            mb: 1,
            textTransform: "none",
            color: "blue",
            outline: "none",
            border: "none",
            background: "none",
          }}
        >
          Download Sample File?
        </Button>
      </Box>
    </>
  );
};

export default UploadExcel;
